import { Button } from "@/components/ui/button";
import { Camera, FileText, Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface PrescriptionStepsNavProps {
  currentStep: number;
  onStepChange: (step: number) => void;
  patientId: string | null;
  hasItems: boolean;
}

export function PrescriptionStepsNav({
  currentStep,
  onStepChange,
  patientId,
  hasItems
}: PrescriptionStepsNavProps) {
  const steps = [
    {
      id: 1,
      label: "Captura",
      icon: Camera,
      canAccess: true
    },
    {
      id: 2,
      label: "Receita",
      icon: FileText,
      canAccess: true
    },
    {
      id: 3,
      label: "Finalização",
      icon: Check,
      canAccess: !!patientId && hasItems
    }
  ];

  return (
    <div className="border-b bg-card">
      <div className="container mx-auto px-4">
        <nav className="flex gap-2 overflow-x-auto">
          {steps.map((step) => {
            const Icon = step.icon;
            const isActive = currentStep === step.id;
            const canAccess = step.canAccess;

            return (
              <Button
                key={step.id}
                variant="ghost"
                onClick={() => canAccess && onStepChange(step.id)}
                disabled={!canAccess}
                className={cn(
                  "flex items-center gap-2 px-6 py-6 rounded-none border-b-2 transition-colors",
                  isActive
                    ? "border-primary text-primary bg-primary/5"
                    : "border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50",
                  !canAccess && "opacity-50 cursor-not-allowed"
                )}
              >
                <Icon className="h-5 w-5" />
                <span className="font-medium">{step.label}</span>
              </Button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
